import SectionHeading from "@/components/base/SectionHeading";
import { readingTips } from "@/mocks/homeContent";

export default function ReadingTips() {
  return (
    <section id="tips" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="How To Read" title={readingTips.title} desc={readingTips.desc} />

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {readingTips.steps.map((tip) => (
            <div key={tip.step} className="relative rounded-lg border border-background-200/70 bg-background-100 p-5">
              <span className="font-display text-3xl text-primary-400">{tip.step}</span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}